/**
 * Map admin sidebar menu path / Turkish name → i18n key.
 * Falls back to original name when no key or missing translation.
 */
const PATH_TO_NAV_KEY: Record<string, string> = {
  '/': 'nav.home',
  '/reports': 'nav.salesReports',
  '/reports/stock': 'nav.stockReports',
  '/reports/members': 'nav.memberReports',
  '/analytics': 'nav.analytics',
  '/orders': 'nav.orders',
  '/purchases': 'nav.purchases',
  '/api-orders': 'nav.apiOrders',
  '/ticket-types': 'nav.ticketTypes',
  '/reports/purchases': 'nav.purchaseReports',
  '/supplier-banks': 'nav.supplierBanks',
  '/marketplace-categories': 'nav.marketplaceCategories',
  '/customer-types': 'nav.customerTypes',
  '/customer-restrictions': 'nav.customerRestrictions',
  '/advert-dopings': 'nav.advertDopings',
  '/seller-requests': 'nav.sellerRequests',
  '/seller-warnings': 'nav.sellerWarnings',
  '/phone-requests': 'nav.phoneRequests',
  '/message-templates': 'nav.messageTemplates',
  '/profile-addons': 'nav.profileAddons',
  '/customer-api': 'nav.customerApi',
  '/order-tickets': 'nav.orderTickets',
  '/fraud-detection': 'nav.frauds',
  '/transactions': 'nav.transactions',
  '/payment-notifications': 'nav.paymentNotifications',
  '/balance-requests': 'nav.balanceRequests',
  '/invoice-records': 'nav.invoices',
  '/adverts': 'nav.adverts',
  '/advert-categories': 'nav.advertCategories',
  '/advert-comments': 'nav.advertComments',
  '/advert-commissions': 'nav.advertCommissions',
  '/advert-rules': 'nav.advertRules',
  '/categories': 'nav.categories',
  '/brands': 'nav.brands',
  '/category-types': 'nav.categoryTypes',
  '/platforms': 'nav.platforms',
  '/products': 'nav.products',
  '/product-types': 'nav.productTypes',
  '/stocks': 'nav.stocks',
  '/virtual-stocks': 'nav.virtualStocks',
  '/suppliers': 'nav.suppliers',
  '/supplier-transactions': 'nav.supplierTransactions',
  '/marketplaces': 'nav.marketplaces',
  '/marketplace-prices': 'nav.marketplacePrices',
  '/marketplace-applications': 'nav.marketplaceApplications',
  '/customers': 'nav.customers',
  '/customer-transactions': 'nav.customerTransactions',
  '/customer-notifications': 'nav.customerNotifications',
  '/staff': 'nav.staff',
  '/permissions': 'nav.permissions',
  '/inbox': 'nav.inbox',
  '/whatsapp': 'nav.whatsapp',
  '/livechat': 'nav.livechat',
  '/tickets': 'nav.tickets',
  '/coupons': 'nav.coupons',
  '/wheel': 'nav.wheelMgmt',
  '/points': 'nav.points',
  '/themes': 'nav.themes',
  '/themes/page-templates': 'nav.pageTemplates',
  '/widgets': 'nav.widgets',
  '/site-contents': 'nav.siteContents',
  '/blogs': 'nav.blogs',
  '/blog-categories': 'nav.blogCategories',
  '/plan-modules': 'nav.planModules',
  '/settings': 'nav.generalSettings',
  '/security': 'nav.security',
  '/messaging': 'nav.messaging',
  '/email-templates': 'nav.emailTemplates',
  '/panel-settings': 'nav.panelSettings',
  '/payments': 'nav.payments',
  '/marketplace-integrations': 'nav.marketplaceIntegrations',
  '/cargo': 'nav.cargo',
  '/shipping-methods': 'nav.shippingMethods',
  '/invoices': 'nav.eInvoice',
  '/sms': 'nav.sms',
  '/partner-api-keys': 'nav.partnerApi',
  '/topup': 'nav.topup',
  '/ai-settings': 'nav.aiSettings',
  '/expenses': 'nav.reports',
}

const NAME_TO_NAV_KEY: Record<string, string> = {
  'Alış-Satış Yönetimi': 'nav.section.sales',
  'Ürün Yönetimi': 'nav.section.products',
  'Üye & Destek Yönetimi': 'nav.section.members',
  'İçerik Yönetimi': 'nav.section.content',
  Raporlar: 'nav.reports',
  'Sipariş & Ödeme Yönetimi': 'nav.ordersPayments',
  'İlan Yönetimi': 'nav.advertsMgmt',
  'Pazaryeri Entegrasyonu': 'nav.marketplaceHub',
  'Kategori Yönetimi': 'nav.categoryMgmt',
  'Stok Yönetimi': 'nav.stockMgmt',
  'Mağaza Yönetimi': 'nav.marketplaceMgmt',
  'Müşteri Yönetimi': 'nav.customerMgmt',
  'Personel Yönetimi': 'nav.staffMgmt',
  'İzin Yönetimi': 'nav.permissions',
  'Destek Yönetimi': 'nav.supportMgmt',
  'Kupon Yönetimi': 'nav.couponMgmt',
  'Şans Çarkı': 'nav.wheel',
  'Tema Yönetimi': 'nav.themeMgmt',
  'Site İçerikleri': 'nav.siteContents',
  'Blog & Haber': 'nav.blogNews',
  'Site Ayarları': 'nav.siteSettings',
  Entegrasyonlar: 'nav.integrations',
}

export function localizeMenuLabel(
  name: string,
  path: string | null | undefined,
  t: (key: string) => string,
): string {
  if (path) {
    const pathname = path.split('?')[0] ?? path
    const pathKey = PATH_TO_NAV_KEY[pathname]
    if (pathKey) {
      const translated = t(pathKey)
      if (translated !== pathKey) return translated
    }
  }

  const nameKey = NAME_TO_NAV_KEY[name]
  if (nameKey) {
    const translated = t(nameKey)
    if (translated !== nameKey) return translated
  }

  return name
}
